module.exports = __webpack_public_path__ + "static/media/menu.6ae00eb6.svg";